import { memo, useMemo } from 'react';
import { Location } from '../../types/Location.interface';
import { compareLocations } from '../../utils';
import CookieSelect, { CookieSelectProps } from './CookieSelect';

export type LocationSelectProps = {
    selectedLocation: number;
    locationOptions: Location[];
    onChange: (selectedLocation: number) => void;
    sortByName?: boolean;
} & Omit<
    CookieSelectProps,
    'selectedValue' | 'options' | 'onChange' | 'label' | 'cookieName' | 'valueKey' | 'labelKeys'
>;

function LocationSelect({
    selectedLocation,
    locationOptions,
    onChange,
    sortByName = true,
    ...props
}: LocationSelectProps) {
    const sortedOptions = useMemo(
        () => (sortByName ? [...locationOptions].sort(compareLocations) : locationOptions),
        [locationOptions, sortByName]
    );

    return (
        <CookieSelect<number>
            selectedValue={selectedLocation}
            options={sortedOptions}
            onChange={onChange}
            valueKey={'id'}
            labelKeys={['code', 'city']}
            label={'Location'}
            cookieName={'location'}
            {...props}
        ></CookieSelect>
    );
}

export default memo(LocationSelect);
